import React from 'react';

const Footer = () => (
  <footer className="pc-footer">
    <div className="footer-wrapper container flex flex-wrap items-center justify-between gap-2 text-sm text-theme-bodycolor">
      <span>&copy; {new Date().getFullYear()} CashAfrica NG</span>
      <a href="mailto:support@cashafrica.co" className="hover:text-primary-500">
        support@cashafrica.co
      </a>
    </div>
  </footer>
);

export default Footer;
